import HCLDX from "@system/config/hcldx";
import System from "src/helper/system";
import $ from "jquery";
import Helper from "src/support/Helper";

let c = System.getParams();

class DashboardAlerts {
    static ALERT_LIST_BY_TYPE = Helper.getPCNUrl() + '/api/pcn/dashboard';
    static ALERT_PCN_EXPORT = Helper.getPCNExportUrl() + '/api/pcn/pcneol/export'
    static STOCK_ALERTS_LIST = Helper.getInventoryUrl() + '/api/inventory/stockalert/searchalerts';
    static STOCK_ALERTS_PRODUCTS = Helper.getInventoryUrl() + '/api/inventory/stockalert/getavailablpartsinstock';
    static EXPORT_STOCK_ALERTS = Helper.getInventoryUrl() + '/api/inventory/stockalert/exportstockalerts';
    static DELETE_STOCK_ALERT = Helper.getInventoryUrl() + '/api/inventory/stockalert/deletealert';
    static GET_ALERT_MANUFACTURER = Helper.getInventoryUrl() + '/api/inventory/stockalert/getalertmanufacturers';
    
    static getAlertRouteURL() {
        return HCLDX.baseURL() + '/resources/my-avnet/alerts';
    }

    static getAlertTabsListRouteURL(extra_c = {}) {
        c['__c'] = 'Alert'
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/my-avnet/alerts?' + $.param(c);
    }
}

export default DashboardAlerts;